import { Link } from 'react-router-dom'
import { useEffect, useMemo, useState } from 'react'
import s from './styles.module.scss'
import images from 'images'
import { getAuthUserData } from 'utils/authManager'
import { subscribeToUserChannels } from '../../../services/chat/firebaseChat'

export default function Main({ fullscreen, setFullscreen }) {
  const userId = useMemo(() => {
    const u = getAuthUserData() || {}
    return (u._id || u.userRefId || u.id)?.toString() || null
  }, [])

  const [missedCallsTotal, setMissedCallsTotal] = useState(0)

  useEffect(() => {
    if (!userId) return
    const unsub = subscribeToUserChannels(list => {
      const total = (list || []).reduce((sum, ch) => {
        const n = ch?.missedCallCountByUser?.[userId] || 0
        return sum + (Number.isFinite(n) ? n : 0)
      }, 0)
      setMissedCallsTotal(total)
    })
    return () => unsub && unsub()
  }, [userId])

  return (
    <>
      <div id='nav' className={s.outernav}>
        <nav className={s.nav}>
          <div className={s.left}>
            <Link to='/home'>
              <img src={images.logoWhite} alt='' />
            </Link>
          </div>

          <div className={s.right}>
            <NavLinks missedCallsTotal={missedCallsTotal} />
          </div>
        </nav>
      </div>

      {!!fullscreen && (
        <div className={s.fullscreenMenu} onClick={() => setFullscreen(false)}>
          <div className={s.close + ' material-icons'}>close</div>
          <NavLinks missedCallsTotal={missedCallsTotal} />
        </div>
      )}

      <div className={s.hamburger + ' material-icons'} onClick={() => setFullscreen(true)}>
        menu
      </div>
    </>
  )
}

const NavLinks = ({ missedCallsTotal = 0 }) => (
  <div className={s.navLinks}>
    {navLinks.map(({ name, path, icon }, i) => (
      <Link key={i} to={path} className={window.location.pathname.startsWith(path) ? s.active : ''} title={name}>
        <span className='material-icons-outlined'>{icon}</span>
        {name === 'Chat' && missedCallsTotal > 0 && (
          <span className={s.badge}>{missedCallsTotal > 99 ? '99+' : missedCallsTotal}</span>
        )}
        <div className={s.fieldName}>{name}</div>
      </Link>
    ))}
  </div>
)

const navLinks = [
  {
    name: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    name: 'Meetings',
    path: '/userAdmin/meetings',
    icon: 'video_call'
  },
  {
    name: 'Chat',
    path: '/userAdmin/chat',
    icon: 'chat'
  },
  {
    name: 'Notifications',
    path: '/userAdmin/notifications',
    icon: 'notifications'
  },
  {
    name: 'My Business',
    path: '/userAdmin/businesses',
    icon: 'business'
  },
  {
    name: 'Edit Profile',
    path: '/userAdmin/editProfile',
    icon: 'person_outline'
  },
  {
    name: 'Membership Card',
    path: '/userAdmin/memberShipCard',
    icon: 'badge'
  },
  {
    name: 'Sign Out',
    path: '/userAdmin/signOut',
    icon: 'logout'
  }
]
